import { useThemesStore } from "@/stores/use-themes-store";
import { useEffect } from "react";

interface UseThemesArgs {
  themeId?: string;
  shouldFetchLicensed?: boolean;
  shouldFetchFeatured?: boolean;
}

export const useThemes = (args?: UseThemesArgs) => {
  const { themeId, shouldFetchLicensed = false, shouldFetchFeatured = false } = args || {};

  const {
    hasLoadedRootThemes,
    commonThemes,
    licensedRootTheme,
    licensedThemes,
    featuredTheme,
    isLoadingRootThemes,
    isLoadingSubThemes,
    isLoadingLicensedThemes,
    isLoadingFeaturedTheme,
    loadRootThemes,
    loadSubThemes,
    loadLicensedThemes,
    loadFeaturedTheme,
  } = useThemesStore();

  useEffect(() => {
    if (!hasLoadedRootThemes) {
      loadRootThemes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasLoadedRootThemes]);

  useEffect(() => {
    if (themeId && hasLoadedRootThemes) {
      loadSubThemes(themeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeId, hasLoadedRootThemes]);

  useEffect(() => {
    if (shouldFetchLicensed && hasLoadedRootThemes) {
      loadLicensedThemes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchLicensed, hasLoadedRootThemes]);

  useEffect(() => {
    if (shouldFetchFeatured && hasLoadedRootThemes) {
      loadFeaturedTheme();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchFeatured, hasLoadedRootThemes]);

  return {
    commonThemes,
    subThemes: themeId ? commonThemes.find(({ id }) => id === themeId)?.subThemes || [] : [],
    licensedRootTheme,
    licensedThemes,
    featuredTheme,
    isLoadingRootThemes,
    isLoadingSubThemes,
    isLoadingLicensedThemes,
    isLoadingFeaturedTheme,
  };
};
